import { render } from "./SigninTemplate.vue?vue&type=template&id=a4e39f50"
import script from "./SigninTemplate.vue?vue&type=script&lang=js"
export * from "./SigninTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script